cloneSymbol